import { AlertCircle } from "lucide-react";
import Seo, { buildBreadcrumbLd } from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import PageHero from "../components/PageHero";
import { company } from "../data/site";

const crumbs = [
  { label: "Startseite", to: "/" },
  { label: "Impressum", to: "/impressum" },
];

const Row = ({ label, value }) => (
  <div className="grid grid-cols-1 gap-1 border-b border-light-gray py-4 sm:grid-cols-[220px_1fr]">
    <span className="font-heading text-sm font-bold text-anthracite">{label}</span>
    <span className="text-base text-mid-gray">{value}</span>
  </div>
);

export default function Impressum() {
  return (
    <div data-testid="page-impressum">
      <Seo path="/impressum" title="Impressum | Rümpeltaxi" description="Impressum von Rümpeltaxi." noindex jsonLd={buildBreadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <PageHero kicker="Rechtliches" title="Impressum" lead="Angaben gemäß § 5 DDG." />
      <section className="bg-white py-16 md:py-24">
        <div className="container-page max-w-3xl">
          <div className="mb-8 flex items-start gap-3 rounded-sm border border-yellow/40 bg-yellow/10 p-5">
            <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-yellow-dark" />
            <p className="text-sm text-anthracite">
              Diese Seite stellt keine Rechtsberatung dar und wurde nicht abschließend anwaltlich
              geprüft.
            </p>
          </div>

          <h2 className="font-heading text-2xl font-bold text-anthracite">Angaben zum Anbieter</h2>
          <div className="mt-6">
            <Row label="Anbieter" value="Thomas Dietrich – Rümpeltaxi" />
            <Row label="Inhaber" value="Thomas Dietrich" />
            <Row label="Unternehmensform" value="Einzelunternehmen, geführt durch Thomas Dietrich" />
            <Row label="Anschrift" value={`${company.street}, ${company.postal} ${company.city}, ${company.country}`} />
            <Row label="Telefon" value={company.phoneDisplay} />
            <Row label="E-Mail" value={company.email} />
          </div>

          <h2 className="mt-12 font-heading text-2xl font-bold text-anthracite">Haftungshinweise</h2>
          <p className="mt-4 text-base leading-relaxed text-mid-gray">
            Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt. Für die
            Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr
            übernommen werden. Für Inhalte externer Links sind ausschließlich deren Betreiber
            verantwortlich.
          </p>
          <p className="mt-4 text-base leading-relaxed text-mid-gray">
            Die auf dieser Website veröffentlichten Inhalte und Werke unterliegen dem deutschen
            Urheberrecht. Eine Verwertung außerhalb der Grenzen des Urheberrechts bedarf der
            vorherigen Zustimmung des jeweiligen Rechteinhabers.
          </p>
        </div>
      </section>
    </div>
  );
}
